import React, { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// @ts-ignore
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons"
import { savePedigreeDocs } from "../../../../../../core/services/api/patientClinicalService"
import {
  uploadAllFiles,
  uploadSpecificFile,
} from "../../../../../../core/services/api/"
import "./UploadFiles.scss"
import Toast from "../../../../../../components/Toast"
import fileUtils from "fileUtils"

function UploadFiles({
  docs,
  updateDocs,
  appointmentId,
  recordId,
  patient,
  type,
  uploadDocument,
  isReadOnly
}: any) {

  const location = useLocation()
  const isStaffTypeView = new URLSearchParams(location.search).get(
    "staffTypeView"
  )
  const handleDrop = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const { files } = e.dataTransfer;
    let fileArr: any = []
    const fileList = Object.entries(files).map(([key, f]) => f)
    //To validate the uploaded file extensions
    const invalidFiles = fileList?.filter((file: any) => !fileUtils.validateFileExtension(file?.name));
    if (invalidFiles?.length > 0) {
      toggleDisplayToast({ text: "Uploaded file extension not allowed", type: "error" })
      return;
    }

    fileList.forEach((file: any) => {
      let tempObj = {
        name: file?.name,
      }
      fileArr.push(tempObj)
    })
    const formData = new FormData()
    fileList.forEach((f: any) => {
      formData.append("files", f)
    })
    // upload file and get the url
    uploadSpecificFile(formData, false)
      .then((data: any) => {
        data.forEach((d: any, index: any) => {
          fileArr[index].blobUrl = d
        })
        let temp = docs.map((d: any) => {
          return { name: d.name, blobUrl: d.blobUrl }
        })
        let tempArr = [...fileArr]
        uploadDocument && uploadDocument([...fileArr])
        //Call Pedigree Docs PUT API
        if (type === "DocumentRMO") {
          uploadAllFiles(tempArr, patient.id)
            .then((data: any) => {
              console.log(data, "after")
              updateDocs(data)
            })
            .catch((err: any) => {
              console.log(err)
            })
        }
        if (type === "pedigree") {
          savePedigreeDocs(tempArr, {
            appointmentId,
            recordId,
          })
            .then((data: any) => {
              updateDocs(data.pedigree)
            })
            .catch((err) => console.log(err))
        }
      })
      .catch((err: any) => {
        const errCode = err?.response?.data?.code;
        if (errCode === 'MaxUploadSizeExceededException') {
          toggleDisplayToast({ text: "File Size should be less than 1 MB", type: "warning" })
        }
        console.log(err, "err in uploading file")
      }
      )
  };

  const drop: any = useRef(null);

  useEffect(() => {
    if (drop.current) {
      drop.current.addEventListener("dragover", handleDragOver);
      drop.current.addEventListener("drop", handleDrop);
    }
  }, [])


  const [displayToast, toggleDisplayToast] = useState<any>()

  const uploadHandler = (event: any) => {
    const fileObj = event.target.files
    let fileArr: any = []
    const fileList = Object.entries(fileObj).map(([key, f]) => f)
    //To validate the uploaded file extensions
    const invalidFiles = fileList?.filter((file: any) => !fileUtils.validateFileExtension(file?.name));
    if (invalidFiles?.length > 0) {
      toggleDisplayToast({ text: "Uploaded file extension not allowed", type: "error" })
      return;
    }

    fileList.forEach((file: any) => {
      let tempObj = {
        name: file?.name,
      }
      fileArr.push(tempObj)
    })
    const formData = new FormData()
    fileList.forEach((f: any) => {
      formData.append("files", f)
    })
    // upload file and get the url
    uploadSpecificFile(formData, false)
      .then((data: any) => {
        data.forEach((d: any, index: any) => {
          fileArr[index].blobUrl = d
        })
        let temp = docs.map((d: any) => {
          return { name: d.name, blobUrl: d.blobUrl }
        })
        let tempArr = [...fileArr]
        uploadDocument && uploadDocument([...fileArr])
        //Call Pedigree Docs PUT API
        if (type === "DocumentRMO") {
          uploadAllFiles(tempArr, patient.id)
            .then((data: any) => {
              console.log(data, "after")
              updateDocs(data)
            })
            .catch((err: any) => {
              console.log(err)
            })
        }
        if (type === "pedigree") {
          savePedigreeDocs(tempArr, {
            appointmentId,
            recordId,
          })
            .then((data: any) => {
              updateDocs(data.pedigree)
            })
            .catch((err) => console.log(err))
        }
      })
      .catch((err: any) => {
        const errCode = err?.response?.data?.code;
        if (errCode === 'MaxUploadSizeExceededException') {
          toggleDisplayToast({ text: "File Size should be less than 1 MB", type: "warning" })
        }
        console.log(err, "err in uploading file")
      }
      )
  }

  const handleDragOver = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };


  return (
    <div className="file-box-main">
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          type={displayToast?.type}
          onClose={() => {
            toggleDisplayToast(false)
          }}
          onCloseText="Close"
          onClickText={null}
        />
      )}
      <div className="file-box-outer" ref={drop}>
        <div className="file-box-inner">
          <div className="file-box">
            <FontAwesomeIcon
              style={{ width: "80px", height: "100px", color: "#687A9F" }}
              icon={faCloudUploadAlt}
            />
            <div className="drag-and-drop">Drag & Drop to Upload files</div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div ref={drop} className="file-inputs">
                <input
                  id="file-upload"
                  multiple
                  type="file"
                  accept="application/pdf"
                  onChange={uploadHandler}
                  disabled={isReadOnly}
                />
                <label className={`${isReadOnly ? "disable" : ""}`} htmlFor="file-upload">Browse File</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UploadFiles
